export enum AIMessageType {
    Prompt = 'Prompt',
    Response = 'Response',
}
